import React, { useCallback, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_GURU } from "@/lib/nav";
import { toast } from "sonner";
import { FilterBar } from "@/components/FilterBar";
import { EP_ALL } from "@/lib/constants";

const F_EMPTY = { siswa: "", jenis: "", guru: "" };

export default function EPPendampinganGuru() {
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState(F_EMPTY);
  const [applied, setApplied] = useState(F_EMPTY);

  const load = useCallback(async () => {
    try {
      // Server allows guru to see ALL assignments (spec: bukan hanya pendampingan guru login)
      const { data } = await api.get("/ekskul-progsus/pendampingan");
      setItems(data);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const visible = items.filter((it) => {
    if (applied.siswa && !(it.nama_siswa || "").toLowerCase().includes(applied.siswa.toLowerCase())) return false;
    if (applied.jenis && it.jenis !== applied.jenis) return false;
    if (applied.guru && !(it.nama_guru || "").toLowerCase().includes(applied.guru.toLowerCase())) return false;
    return true;
  });

  return (
    <Layout nav={NAV_GURU}>
      <PageTitle title="Ekskul & Progsus — Pendampingan" />

      <FilterBar
        filters={filters} setFilters={setFilters}
        onApply={() => setApplied({ ...filters })}
        onReset={() => { setFilters(F_EMPTY); setApplied(F_EMPTY); }}
        dataTestidPrefix="ep-pend-guru-filter"
        fields={[
          { key: "siswa", type: "text", label: "Siswa", placeholder: "Cari nama siswa" },
          { key: "jenis", type: "select", label: "Jenis", options: EP_ALL },
          { key: "guru", type: "text", label: "Pendamping", placeholder: "Cari nama pendamping" },
        ]}
      />

      <section className="pp-card pp-freeze overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="ep-pend-guru-table">
            <thead><tr className="pp-table-header">
              <th className="text-left px-4 py-3">Nama Siswa</th>
              <th className="text-left px-4 py-3">Jenis Ekskul & Progsus</th>
              <th className="text-left px-4 py-3">Pendamping</th>
              <th className="text-left px-4 py-3">Ketunaan</th>
            </tr></thead>
            <tbody>
              {visible.length === 0 && <tr><td colSpan={4} className="text-center py-10 text-slate-400 italic">Belum ada pendampingan.</td></tr>}
              {visible.map((it) => (
                <tr key={it.id} className="pp-row">
                  <td className="px-4 py-3 font-medium">{it.nama_siswa} <span className="text-xs text-slate-400 font-mono">({it.nis_siswa})</span></td>
                  <td className="px-4 py-3 text-xs">{it.jenis}</td>
                  <td className="px-4 py-3 text-xs">{it.nama_guru}</td>
                  <td className="px-4 py-3 text-xs text-slate-600">{it.ketunaan || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </Layout>
  );
}
